import { render, staticRenderFns } from "./Demandas.vue?vue&type=template&id=643d5d0d&scoped=true&"
import script from "./Demandas.vue?vue&type=script&lang=js&"
export * from "./Demandas.vue?vue&type=script&lang=js&"
import style0 from "./Demandas.vue?vue&type=style&index=0&id=643d5d0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643d5d0d",
  null
  
)

export default component.exports